// extracted by mini-css-extract-plugin
export default {"callout":"MFwu0thuSfsm1ycLhkCr","inner":"Jv8d6W5JW4s3Jv95Pkgw","innerStacked":"_71N2pba9IBhjQPXFnds","content":"EhjcTnWT3gIuasCTUY1d"};